<template><div><component-combinator component-name="DtCollapsible" /><p class="d-docsite--paragraph">The collapsible component consists of two parts: the anchor and the content. If the anchor slot is not filled, the anchor will default to a basic button with text. The content must be provided and is the element that can be hidden or shown when the anchor is clicked.</p>
<h3 id="basic-usage-without-anchor-slot" tabindex="-1" class="d-docsite--header-3">Basic Usage Without Anchor Slot <a class="header-anchor d-link d-docsite--link d-link" href="#basic-usage-without-anchor-slot" aria-hidden="true">#</a></h3>
<code-example class="d-d-block" source-code='&lt;div&gt;
  &lt;dt-collapsible
    class=&quot;d-fc-primary&quot;
    anchorText=&quot;Label 1&quot;
    maxWidth=&quot;340px&quot;
    initial-focus-element=&quot;first&quot;
    &gt;
    &lt;template #content&gt;
      &lt;div class=&quot;d-ta-center d-ba d-bc-warning d-bgc-warning d-bas-dotted d-baw2 d-p-100 d-code--sm&quot;&gt;(content slot)&lt;/div&gt;
    &lt;/template&gt;
  &lt;/dt-collapsible&gt;
  &lt;dt-collapsible
    anchorText=&quot;Label 2&quot;
    maxWidth=&quot;340px&quot;
    initial-focus-element=&quot;first&quot;
  &gt;
    &lt;template #content&gt;
      &lt;div class=&quot;d-ta-center d-ba d-bc-warning d-bgc-warning d-bas-dotted d-baw2 d-p-100 d-code--sm&quot;&gt;(content slot)&lt;/div&gt;
    &lt;/template&gt;
  &lt;/dt-collapsible&gt;
&lt;/div&gt;'>
<div>
  <dt-collapsible
    class="d-fc-primary"
    anchorText="Label 1"
    maxWidth="340px"
    initial-focus-element="first"
    >
    <template #content>
      <div class="d-ta-center d-ba d-bc-warning d-bgc-warning d-bas-dotted d-baw2 d-p-100 d-code--sm">(content slot)</div>
    </template>
  </dt-collapsible>
  <dt-collapsible
    anchorText="Label 2"
    maxWidth="340px"
    initial-focus-element="first"
  >
    <template #content>
      <div class="d-ta-center d-ba d-bc-warning d-bgc-warning d-bas-dotted d-baw2 d-p-100 d-code--sm">(content slot)</div>
    </template>
  </dt-collapsible>
</div>
</code-example>
<h3 id="with-anchor-slot" tabindex="-1" class="d-docsite--header-3">With Anchor Slot <a class="header-anchor d-link d-docsite--link d-link" href="#with-anchor-slot" aria-hidden="true">#</a></h3>
<code-example class="d-d-block" source-code='&lt;dt-collapsible :open=&quot;isOpen&quot;&gt;
  &lt;template #anchor&gt;
    &lt;dt-button @click=&quot;toggleIsOpen&quot;&gt;
      Click Me!
    &lt;/dt-button&gt;
  &lt;/template&gt;
  &lt;template #content&gt;
    &lt;div&gt;
      This will be shown in the expanded area.
    &lt;/div&gt;
  &lt;/template&gt;
&lt;/dt-collapsible&gt;'>
<dt-collapsible :open="isOpen">
  <template #anchor>
    <dt-button @click="toggleIsOpen">
      Click Me!
    </dt-button>
  </template>
  <template #content>
    <div>
      This will be shown in the expanded area.
    </div>
  </template>
</dt-collapsible>
</code-example>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="collapsible" /></div></template>


<script setup>
import { ref } from 'vue';

const isOpen = ref(false);

function toggleIsOpen () {
  isOpen.value = !isOpen.value;
}
</script>